export default __webpack_public_path__ + "static/media/low_credit.40284a8e.svg";